import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// This component protects routes that require authentication.
// Usage: Wrap <PrivateRoutetsx> around routes that need to be private.

interface PrivateRouteProps {
  isAuthenticated: boolean;
  redirectPath?: string;
}

const PrivateRoutetsx: React.FC<PrivateRouteProps> = ({
  isAuthenticated,
  redirectPath = '/login',
}) => {
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  return <Outlet />;
};

export default PrivateRoutetsx;